export enum ETipoEstoque {
    Padrao = 1,
    Sintetico = 2,
    Analitico = 3
}
